// tslint:disable
/**
 * Robotic Platform Pattern Generation API
 * WebSocket API contract for generating palletization strategy templates and layer layouts.  This module is exposed through the Robotic Platform WebSocket dispatcher (not a standalone REST API). The OpenAPI path below documents the JSON request/response message payload for the `generatePatternPlan` handler.  Transport notes: - Connect to the WebSocket server and send a JSON object with top-level `type: generatePatternPlan` - Receive one JSON response frame for the request (success or handler-level error) - Validation and internal handler errors are encoded in the JSON response body with `status: error` - No module-level authentication or rate limiting is implemented in this repository 
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { BoxPlacement } from './box-placement';

/**
 * 
 * @export
 * @interface StrategyLayerTemplate
 */
export interface StrategyLayerTemplate {
    /**
     * 
     * @type {string}
     * @memberof StrategyLayerTemplate
     */
    type: StrategyLayerTemplateTypeEnum;
    /**
     * Symmetry label for this layer template. `A` always uses `none`; `B` layers use this field as the frontend selection key. 
     * @type {string}
     * @memberof StrategyLayerTemplate
     */
    symmetry: StrategyLayerTemplateSymmetryEnum;
    /**
     * Layer bottom-face Z relative to the nominal pallet top plane.
     * @type {number}
     * @memberof StrategyLayerTemplate
     */
    z: number;
    /**
     * Box height for the layer template.
     * @type {number}
     * @memberof StrategyLayerTemplate
     */
    height: number;
    /**
     * 
     * @type {Array<BoxPlacement>}
     * @memberof StrategyLayerTemplate
     */
    boxes: Array<BoxPlacement>;
}

/**
    * @export
    * @enum {string}
    */
export enum StrategyLayerTemplateTypeEnum {
    A = 'A',
    B = 'B'
}
/**
    * @export
    * @enum {string}
    */
export enum StrategyLayerTemplateSymmetryEnum {
    NONE = 'none',
    MIRROR_X = 'mirror_x',
    MIRROR_Y = 'mirror_y',
    MIRROR_XY = 'mirror_xy',
    ROTATE_180 = 'rotate_180'
}



